
import React from 'react';
import TicketCard from './TicketCard';
import { ticketTypes } from './ticketTypes';
import { getAnimationDelay } from '@/lib/utils';

interface TicketListProps {
  forceRender: number;
  updateCount: number;
}

const TicketList = ({ forceRender, updateCount }: TicketListProps) => {
  const timestamp = `${Date.now()}`;
  
  return (
    <div className="grid grid-cols-1 landscape:grid-cols-3 lg:grid-cols-3 gap-12 w-full px-4 landscape:px-2 lg:max-w-7xl lg:mx-auto lg:px-8">
      {ticketTypes.map((ticket, index) => (
        <div 
          key={`ticket-wrapper-${ticket.id}`} 
          className="animate-scale-in transform hover:scale-105 transition-transform duration-300"
          style={{ 
            animationDelay: getAnimationDelay(index),
            animationFillMode: 'both'
          }}
        >
          <TicketCard 
            key={`ticket-card-${ticket.id}`}
            ticket={ticket} 
            index={index}
            timestamp={timestamp}
            forceRender={forceRender}
            updateCount={updateCount}
          />
        </div>
      ))}
    </div>
  );
};

export default TicketList;
